import { createBEM } from "@/libs";
import { useToggle, useUnmount } from "ahooks";
import { PasscodeInput, Popup, SafeArea } from "antd-mobile";
import { PropsWithChildren, useEffect, useState } from "react";
import { ShowResult, usePopup } from "../Popup";
import { PwsInput } from "./Keyboard";
import styles from "./index.module.scss";
import "./index.scss";

type PopupProps = {
  visible: boolean;
  length?: number;
  onSubmit: (val: string) => void;
  onClose: () => void;
};

export const SecurityPwdPopup = ({
  visible,
  length = 6,
  onSubmit,
  onClose,
}: PropsWithChildren<PopupProps>) => {
  const [value, setValue] = useState<string>("");
  // const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    if (!visible) {
      setValue("");
    } 
  }, [visible]);

  useEffect(() => {
    if (value.length === length) {
      onSubmit(value);
    }
  }, [value]);

  return (
    <Popup
      visible={visible}
      className={styles.popup}
      onClose={onClose}
      onMaskClick={onClose}
    >
      <div className={styles.content}>
        <PasscodeInput
          ref={(node) => node?.focus()}
          length={length}
          seperated
          onChange={(value) => {
            setValue(value);
          }}
          keyboard={<PwsInput />}
        />
      </div>

      <SafeArea position="bottom" />
    </Popup>
  );
};

let handler: ShowResult;
export const useSecurityPwdPopup = ({
  length = 6,
  onSubmit,
  onClose,
}: PropsWithChildren<{
  length?: number;
  onSubmit: (val: string) => void;
  onClose?: () => void;
}>) => {
  const b = createBEM("i-security-pwd");
  const [show] = usePopup();
  const [value, setValue] = useState<string>("");
  const [visible, action] = useToggle();

  useEffect(() => {
    if (visible) {
      action.setRight();
    } else {
      setValue("");
      action.setLeft();
    }
  }, [visible]);

  useEffect(() => {
    if (value.length === length) {
      onSubmit(value);
    }
  }, [value]);

  useUnmount(() => {
    handler?.close();
  });

  return [
    () => {
      handler = show({
        closeOnClick: true,
        className: b(),
        content: (
          <>
            <PasscodeInput
              className={b("passcode-input")}
              ref={(node) => node?.focus()}
              length={length}
              seperated
              value={value}
              onChange={(value) => {
                setValue(value);
              }}
              keyboard={<PwsInput />}
            />
          </>
        ),
      });
    },
  ];
};
